// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  actorUserId: __t.string(),
  id: __t.string(),
  orgId: __t.string(),
  name: __t.string(),
  kind: __t.string(),
  config: __t.string(),
  spaceId: __t.string(),
  allowWrite: __t.bool(),
  ciphertext: __t.option(__t.string()),
  lastError: __t.string(),
};
